<script setup lang="ts">
import { cn } from '@/lib/utils.ts';
import { ChevronDownIcon } from '@radix-icons/vue';
import { AccordionHeader, AccordionTrigger, type AccordionTriggerProps } from 'radix-vue';
import { type HTMLAttributes, computed } from 'vue';

const props = defineProps<AccordionTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});
</script>

<template>
  <AccordionHeader class="flex">
    <AccordionTrigger
      v-bind="delegatedProps"
      class="accordion-trigger"
      :class="
        cn(
          'slide-underline flex flex-1 items-start justify-between py-4 text-sm font-medium [&[data-state=open]>svg]:rotate-180',
          props.class,
        )
      "
    >
      <slot />
      <slot name="icon">
        <ChevronDownIcon class="h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200" />
      </slot>
    </AccordionTrigger>
  </AccordionHeader>
</template>

<style>
.slide-underline {
  > * {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 2px;
      background-color: currentColor;
      transition: width 200ms ease-in-out;
    }
  }

  &:hover > *::after {
    width: 100%;
  }
}
</style>
